import { DuckProvider } from "duck/ui/chat/contexts/DuckContext";
import { DuckSidebarResizeContextProvider } from "duck/ui/chat/contexts/DuckSidebarResizeContextProvider";
import { useOktaAuth } from "@okta/okta-react";

import { AttributesContextWrapper } from "./AttributesContext";
import ConfigContextWrapper from "./ConfigContext";
import EventRegistryContextWrapper from "./EventRegistryContext";
import { SchemaDefinitionCacheContextWrapper } from "./SchemaDefinitionCacheContext";
import { ContextWrapComponentProps, ContextWrapper } from "./types";
import VehicleECUsContextWrapper from "./VehicleECUsContextWrapper";
import VehicleOptionsContextWrapper from "./VehicleOptionsContextWrapper";

// Note: ChatProvider is now in CommonRoutesWrapper to ensure its inside Router context
// These mount outside LaunchDarklyWrapper, so useFlags() in them returns no flags.
const CONTEXT_WRAPPERS: ContextWrapper[] = [
  AttributesContextWrapper,
  EventRegistryContextWrapper,
  ConfigContextWrapper,
  SchemaDefinitionCacheContextWrapper,
  VehicleECUsContextWrapper,
  VehicleOptionsContextWrapper,
  DuckProvider,
  DuckSidebarResizeContextProvider,
];

const ContextWrappers = ({ children }: ContextWrapComponentProps) => {
  const { authState } = useOktaAuth();

  if (!authState || !authState.isAuthenticated) {
    return children;
  }

  // Create a (nested) stack of context providers
  return CONTEXT_WRAPPERS.reduce(
    (acc, Wrapper) => <Wrapper>{acc}</Wrapper>,
    children
  );
};

export default ContextWrappers;
